import { isStripeGooglePayEnabled } from 'utils/stripe';
import { stripeGooglePayPaymentAttempt } from '../../actions/stripeGooglePay';
import useStripeExpressWallet from './useStripeExpressWallet';
import useStripeGooglePaySdk from './useStripeGooglePaySdk';

/**
 * useStripeGooglePay hook.
 * Thin wrapper over the shared `useStripeExpressWallet` orchestrator bound to Google Pay:
 * tenant gating via `isStripeGooglePayEnabled`, the `google_pay` payment type, the Google Pay
 * payment attempt, and the Google Pay SDK hook.
 *
 * @param {object} props - onPaymentButtonClick.
 * @param {Function} props.onPaymentButtonClick - Callback when the Google Pay button is clicked;
 *   receives `{ resolve, reject }` to gate the wallet sheet on checkout validations.
 * @param {Function} [props.beforeWalletPayment] - Optional current Quick Purchase check before dispatch.
 * @returns {object} Google Pay ECE state and container ref.
 */
function useStripeGooglePay({ onPaymentButtonClick, beforeWalletPayment }) {
  return useStripeExpressWallet({
    onPaymentButtonClick,
    beforeWalletPayment,
    enabled: isStripeGooglePayEnabled(),
    paymentType: 'google_pay',
    paymentAttempt: stripeGooglePayPaymentAttempt,
    useWalletSdk: useStripeGooglePaySdk,
  });
}

export default useStripeGooglePay;
